import AccountCreation from "@/components/signup/account-creation";
import { LoomOverlayTemplate } from "@/components/signup/layouts";

import {
    InputSubmitButton,
    Headings,
    GetStartedText,
    FreeForTenUsersText
} from "../../components";

export const LoggedOutLoom = () => {
    return (
        <LoomOverlayTemplate size="sm">
            <Headings
                main={<GetStartedText productName="Loom" />}
                sub={<FreeForTenUsersText />}
            />
            <AccountCreation Input={<InputSubmitButton />} Submit={null} />
        </LoomOverlayTemplate>
    );
};
